export const format = (num) => {
  num = num ?? 0
  num = num.toString().replace(/\$|\,/g, "")
  if (isNaN(num)) num = "0"
  let sign = num == (num = Math.abs(num))
  num = Math.floor(num * 100 + 0.50000000001)
  let cents = num % 100
  num = Math.floor(num / 100).toString()
  if (cents < 10) cents = "0" + cents
  for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) num = num.substring(0, num.length - (4 * i + 3)) + "," + num.substring(num.length - (4 * i + 3))
  if (sign) {
    sign = ""
  } else {
    sign = "-"
  }
  return sign + num + "." + cents
}

export const fromString = (money) => {
  return Math.round(parseFloat(parseFloat(format(money).replace(/,/g, "")).toFixed(2)) * 100)
}

const removeDecimals = (money) => money.split(".")[0]

export const fromInt = (money, opts = {}) => {
  const {showDecimals = true} = opts
  const value = format(money / 100)
  return showDecimals ? value : removeDecimals(value)
}

export const formatInDollars = (money) => {
  return "$" + fromInt(Math.abs(money))
}

export const asShort = (integer) => {
  return "$" + fromInt(integer, {showDecimals: false})
}
